import React from "react";
import tw from "twin.macro";
import styled from "styled-components";

const Container = tw.div`border border-gray-200 rounded-lg p-4 bg-white`;
const Title = tw.h3`text-sm font-bold text-gray-700 mb-3`;
const ProductList = tw.div`space-y-2`;

const ProductRow = tw.div`flex items-center justify-between p-2 bg-gray-500 rounded border border-gray-100`;
const ProductInfo = tw.div`flex-1`;
const ProductName = tw.div`text-sm font-semibold text-gray-800`;
const ProductDetails = tw.div`text-xs text-gray-500 mt-1`;
const ProductPrice = tw.div`text-sm font-bold text-green-600 text-right`;

const TotalRow = tw.div`flex justify-between items-center pt-3 mt-3 border-t border-gray-200`;
const TotalLabel = tw.div`text-sm font-bold text-gray-700`;
const TotalAmount = tw.div`text-lg font-bold text-green-600`;

const EmptyState = tw.div`text-center text-gray-400 py-6 text-sm italic`;

const RemoveBtn = styled.button`
  ${tw`text-red-500 hover:text-red-700 text-xs font-semibold ml-2 transition`}
`;

/**
 * ProductSummary Component
 * Displays a summary of selected marketplace products with prices
 */
export default function ProductSummary({ products = [], onRemove, showRemove = false }) {
    const calculateTotal = () => {
        return products.reduce((sum, product) => {
            const itemTotal = (product.unitPrice || 0) * (product.quantity || 0);
            return sum + itemTotal;
        }, 0);
    };

    if (products.length === 0) {
        return (
            <Container>
                <Title>📦 Selected Products</Title>
                <EmptyState>No products selected yet</EmptyState>
            </Container>
        );
    }

    return (
        <Container>
            <Title>📦 Selected Products ({products.length})</Title>
            <ProductList>
                {products.map((product, index) => {
                    const itemTotal = (product.unitPrice || 0) * (product.quantity || 0);
                    return (
                        <ProductRow key={product.productId || index}>
                            <ProductInfo>
                                <ProductName>
                                    {product.productName}
                                    {showRemove && onRemove && (
                                        <RemoveBtn 
                                            type="button"
                                            onClick={() => onRemove(product.productId)}
                                        >
                                            ✕ Remove
                                        </RemoveBtn>
                                    )}
                                </ProductName>
                                <ProductDetails>
                                    {product.quantity} {product.measureUnit} × ₦{product.unitPrice.toLocaleString()}
                                </ProductDetails>
                            </ProductInfo>
                            <ProductPrice>
                                ₦{itemTotal.toLocaleString()}
                            </ProductPrice>
                        </ProductRow>
                    );
                })}
            </ProductList>

            <TotalRow>
                <TotalLabel>Total Cost:</TotalLabel>
                <TotalAmount>₦{calculateTotal().toLocaleString()}</TotalAmount>
            </TotalRow>
        </Container>
    );
}
